import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { createStore } from 'redux'
import reducer from './reducers/index'
import { Provider } from 'react-redux'

import {
  SET_GOOGLE,
  SET_USER,
  SET_FIREBASE
} from './actions/index'



// ===============================================

const store = createStore(reducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);



// =========================================================

const firebase = require('firebase/app');
// all 3 are optional and you only need to require them at the start
require('firebase/auth');
require('firebase/database');
require('firebase/storage');
require('firebase/firestore');

// Initialize Firebase
const config = {
  apiKey: 'AIzaSyDA908eWOqW0j2jBgZqzN_6kVabiE-iWW8',
  authDomain: 'wanna-today.firebaseapp.com',
  databaseURL: 'https://wanna-today.firebaseio.com',
  projectId: 'wanna-today',
  storageBucket: '',
  messagingSenderId: '577851894442'
};

// let currentUser;
// let google;

firebase.initializeApp(config);

store.dispatch({
  type: SET_FIREBASE,
  firebase: firebase
});

firebase
  .auth()
  .onAuthStateChanged(function(user) {
    if (user) {
      // User is signed in.

      firebase
        .firestore()
        .collection('bees')
        .doc(user.uid)
        .get()
        .then(function(doc) {
            if (doc.exists) {
                console.log("Auth id:", user);
                store.dispatch({
                  type: SET_USER,
                  user: user
                });
            } else {
                // doc.data() will be undefined in this case
                console.log("No such user!");

                firebase
                .firestore()
                .collection('bees')
                .doc(user.uid)
                .set({
                    uid: user.uid
                }, { merge: true })// TODO: Use create
                .then(function() {
                    console.log("Document successfully written!");

                    store.dispatch({
                      type: SET_USER,
                      user: user
                    });

                    // updateApp(google, firebase, currentUser);
                })
                .catch(function(error) {
                    console.error("Error writing document: ", error);

                    store.dispatch({
                      type: SET_USER,
                      user: null
                    });
                });
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);

            store.dispatch({
              type: SET_USER,
              user: null
            });
        });
    } else {
      // User is signed out.
      // ...

      store.dispatch({
        type: SET_USER,
        user: null
      });
    }
  });

firebase
  .auth()
  .signInAnonymously()
  .catch(function(error) {
    // Handle Errors here.
    var errorCode = error.code;
    var errorMessage = error.message;
    // ...

    console.log('Error code: ' + errorCode + ', message: ' + errorMessage);
  });

//updateApp(google, firebase, currentUser);
registerServiceWorker();

window.onGoogleMapsLoaded = function() {
  const google = window.google;
  console.log('Loaded google maps: ' + google.maps);


  store.dispatch({
    type: SET_GOOGLE,
    google: google
  });

  // updateApp(google, firebase, currentUser);
};

function loadGoogleMaps() {
  var script = document.createElement('script');
  script.async = true;
  script.src =
    'https://maps.googleapis.com/maps/api/js?key=AIzaSyA3Zh63WAJ7KhnnTv3_0RHf-nSr_X0U_AU&callback=onGoogleMapsLoaded';
  document.head.appendChild(script);
}

loadGoogleMaps();



// WEBPACK FOOTER //
// ./src/index.js